import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Col,
  Container,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import ServiceStructure from "../../components/Services/structure/ServiceStructure"

const Disposal = () => {
  const [menu, setMenu] = useState(false)
  const toggle = () => {
    setMenu(!menu)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Disposal Guidance | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">
                  Guidance on the disposal of various products
                </h6>

                <ServiceStructure
                  detailsType="disposal"
                  url="product-disposal-apply"
                  serviceType="Guidance on the disposal of various products"
                  department="Environmental Compliance  &amp; Enforcement Division"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Disposal
